export default "__VITE_ASSET__Bd2qvok8__"